(function () {
  'use strict';

  // Standalone "reveal header on scroll up" behaviour.
  //
  // The theme's own implementation is not used here: forcing the
  // header to position:fixed breaks the intersection check that the
  // theme's JS relies on to detect scroll direction, so it would
  // get stuck reporting data-scroll-direction="none". This script
  // measures scrolling directly instead, so the two never fight.

  function init() {
    var headerSection = document.querySelector('.header-section');
    if (!headerSection) return;

    // Spacer keeps the page from jumping when the header switches
    // from normal flow to fixed positioning.
    var spacer = document.createElement('div');
    spacer.className = 'header-sticky-spacer';
    spacer.style.display = 'none';
    headerSection.parentNode.insertBefore(spacer, headerSection.nextSibling);

    var lastY = window.scrollY;
    var ticking = false;

    function update() {
      var y = window.scrollY;
      var headerHeight = headerSection.offsetHeight;

      if (y <= headerHeight) {
        // At the very top: header sits in normal flow.
        headerSection.classList.remove('is-stuck', 'is-visible');
        spacer.style.display = 'none';
      } else {
        headerSection.classList.add('is-stuck');
        spacer.style.display = 'block';
        spacer.style.height = headerHeight + 'px';

        if (y < lastY) {
          headerSection.classList.add('is-visible');   // scrolling up
        } else if (y > lastY) {
          headerSection.classList.remove('is-visible'); // scrolling down
        }
      }

      lastY = y;
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );

    // Wait until after the first paint before measuring.
    //
    // update() reads offsetHeight, which forces a layout calculation.
    // Running that on DOMContentLoaded — before stylesheets have
    // necessarily been applied — can make the browser paint the page
    // unstyled for a moment. Firefox reports this as "Layout was
    // forced before the page was fully loaded". One animation frame
    // is enough to land after the first paint, and the delay is not
    // perceptible.
    requestAnimationFrame(update);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
